import { useState, useEffect } from 'react';

export type Platform = 'unknown' | 'ios' | 'android';

const usePlatform = () => {
  const [platform, setPlatform] = useState<Platform>('unknown');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod|Macintosh/.test(userAgent)) {
      setPlatform('ios');
    } else if (/android/i.test(userAgent)) {
      setPlatform('android');
    } else {
      setPlatform('unknown'); // Default to 'unknown' if the platform cannot be determined
    }
  }, []);

  return platform;
};

export default usePlatform;
